import React from "react"
import {FieldInlineEditableProps} from "../../render/inline-editable";

export default function FieldProto_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]

    return <div className="ui5-txt-default ui5-txt-red">{props.field.type}.inlineEditable</div>

}